import compose from "ramda/src/compose";

export default function () {
    //Scroll class
    const headers = document.querySelectorAll(".header");
    window.addEventListener('scroll', ()=>{
        if(window.pageYOffset > 30){
            headers.forEach(header => {
                header.classList.add("header--scrolled")
            })
        }else{
            headers.forEach(header => {
                header.classList.remove("header--scrolled")
            })
        }
    })
    // Desktop only
    if (window.innerWidth < 1024) {
        return;
    }
    const mainMenu = document.querySelectorAll('.main-menu')
    const AllSubMenus = document.querySelectorAll('.menu-items-children')
    mainMenu.forEach(menu => {
        menu.addEventListener('mouseenter', item => {
            let parentMenu = item.target
            mainMenu.forEach(main => {
                main.classList.remove('open')
            })
            parentMenu.classList.toggle('open')
            let subMenu = parentMenu.querySelector('.menu-items-children')
            AllSubMenus.forEach(subMenu => {
                subMenu.classList.remove('active')
            })
            subMenu.classList.add('active')
        })
        menu.addEventListener('mouseleave', item => {
            let parentMenu = item.target
            parentMenu.classList.remove('open')
            AllSubMenus.forEach(subMenu => {
                subMenu.classList.remove('active')
            })
        })
    })
}